"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadServiceLineMaterialType = void 0;
var LeadServiceLineMaterialType;
(function (LeadServiceLineMaterialType) {
    LeadServiceLineMaterialType[LeadServiceLineMaterialType["Lead"] = 0] = "Lead";
    LeadServiceLineMaterialType[LeadServiceLineMaterialType["Cast Iron"] = 1] = "Cast Iron";
    LeadServiceLineMaterialType[LeadServiceLineMaterialType["PVC"] = 2] = "PVC";
    LeadServiceLineMaterialType[LeadServiceLineMaterialType["Copper"] = 3] = "Copper";
    LeadServiceLineMaterialType[LeadServiceLineMaterialType["Galvanized"] = 4] = "Galvanized";
    LeadServiceLineMaterialType[LeadServiceLineMaterialType["HDPE"] = 5] = "HDPE";
    LeadServiceLineMaterialType[LeadServiceLineMaterialType["Unknown"] = 6] = "Unknown";
    LeadServiceLineMaterialType[LeadServiceLineMaterialType["PEX"] = 7] = "PEX";
})(LeadServiceLineMaterialType = exports.LeadServiceLineMaterialType || (exports.LeadServiceLineMaterialType = {}));
//# sourceMappingURL=LeadServiceLineMaterialType.js.map